import { Route } from 'react-router-dom';
import { ExperienceEventList } from './list';
import { ExperienceEventShow } from './show';
import { ExperienceEventCreate } from './create';

export const ExperienceEventsRoute = (
  <Route path="events">
    <Route index element={<ExperienceEventList />} />
    <Route path=":id" element={<ExperienceEventShow />} />
    <Route path="create" element={<ExperienceEventCreate />} />
  </Route>
);
